import { createFileRoute } from "@tanstack/react-router";
import { StateLocationsHub, type StateCity } from "@/components/site/StateLocationsHub";
import charlotte__asset from "@/assets/restore/locations/charlotte.jpg.asset.json";
import cornelius__asset from "@/assets/restore/locations/cornelius.jpg.asset.json";
import raleigh__asset from "@/assets/restore/locations/raleigh.jpg.asset.json";

const map = (q: string) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;

const cities: StateCity[] = [
  {
    name: "Charlotte",
    address: "7725 Ballantyne Commons Parkway, Suite 101",
    img: charlotte__asset.url,
    mapUrl: map("7725 Ballantyne Commons Parkway Charlotte NC"),
    to: "/locations/restore-charlotte/",
  },
  {
    name: "Cornelius",
    address: "19109 West Catawba Ave, Suite 200",
    img: cornelius__asset.url,
    mapUrl: map("19109 West Catawba Ave Cornelius NC"),
    to: "/locations/restore-charlotte/",
  },
  {
    name: "Raleigh",
    address: "4509 Creedmoor Rd, Suite 201",
    img: raleigh__asset.url,
    mapUrl: map("4509 Creedmoor Rd Raleigh NC"),
    to: "/locations/north-carolina/raleigh/",
  },
];

export const Route = createFileRoute("/locations/north-carolina/")({
  head: () => ({
    meta: [
      { title: "North Carolina Hair Transplants | RESTORE® Hair" },
      {
        name: "description",
        content:
          "RESTORE® Hair in North Carolina. Book a free personal hair loss consultation at our Charlotte, Cornelius, and Raleigh locations.",
      },
      { property: "og:title", content: "North Carolina Hair Transplants | RESTORE® Hair" },
      {
        property: "og:description",
        content:
          "See RESTORE® Hair locations across North Carolina and book a free consultation.",
      },
      { property: "og:url", content: "https://restorehair.com/locations/north-carolina/" },
    ],
    links: [{ rel: "canonical", href: "https://restorehair.com/locations/north-carolina/" }],
  }),
  component: () => <StateLocationsHub stateName="North Carolina" cities={cities} />,
});